import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a number as currency without symbol.
 * Uses US number formatting (comma as thousands separator).
 *
 * @example
 * {{ 10000 | currencyFormat }} → "10,000"
 * {{ 1234567.89 | currencyFormat }} → "1,234,568"
 */
@Pipe({
  name: 'currencyFormat',
  standalone: true,
})
export class CurrencyFormatPipe implements PipeTransform {
  private readonly formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  transform(value: number | null | undefined): string {
    if (value == null) return '0';
    return this.formatter.format(value);
  }
}
